import { aanvraagDetailApi } from '@/api/aanvraag-detail.api';
import leadAanvraagApi from '@/api/lead-aanvraag.api';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';
import { useFlowUrls } from '@/use/use-flow-urls';
import router from '@/router';
import { useRouteExtensions } from '@/use/use-route-extensions';
import { viewType } from '@/api/lead-aanvraag.api';
import { useRootStore } from '@/stores/index';
import aanbodApi from '@/api/aanbod.api';

export const useLoadFromPermalink = () => {
  async function loadFromPermalink() {
    const { lang, currentRoute } = useRouteExtensions();
    const { leadAanvraag } = await leadAanvraagApi.getLeadAanvraagByK(currentRoute.value.query.k);
    const leadAanvraagStore = useLeadAanvraagStore();
    leadAanvraagStore.updateLeadAanvraag(leadAanvraag);

    const rootStore = useRootStore();

    let aanbodDefinitie;
    aanbodDefinitie = await aanbodApi.getAanbodDefinitieByVersion(
      leadAanvraag.aanbodVersieId,
      leadAanvraag.subflowVersies.map((sf) => sf.subflowVersieId),
      lang
    );

    leadAanvraagStore.setAndSaveValueOnLeadAanvraagWithOverrideAanbodAndLang(
      {
        contentLocator: 'loadedFromPermalink',
        value: new Date(Date.now())
      },
      aanbodDefinitie.aanbodNaam,
      lang.value
    );

    if (leadAanvraag.verwerktNaarAanvraagBeheer || leadAanvraag.finalized) {
      if (aanbodDefinitie.bedankingsscherm) {
        return router.push({
          name: `Bedankingsscherm-${lang.value}`,
          query: {
            aanbod: aanbodDefinitie.aanbodNaam,
            aanvraagId: leadAanvraag.aanvraagId
          }
        });
      } else {
        window.location = await aanvraagDetailApi.getRedirectToAanvraagDetail(
          leadAanvraag?.immutableData?.verwerkNaarAanvraagId ?? leadAanvraag.aanvraagId,
          leadAanvraag?.immutableData?.verwerkNaarAanvraagId
            ? undefined
            : aanbodDefinitie.aanbodNaam,
          lang.value,
          'ViaXeriusPermalink'
        );
        return;
      }
    }

    const nextPagePointer = await leadAanvraagApi.getNextPage(
      leadAanvraag.aanvraagId,
      aanbodDefinitie.aanbodNaam,
      undefined,
      true
    );

    const flowUrls = useFlowUrls();

    switch (nextPagePointer.viewType) {
      case viewType.overzicht:
        await router.push(
          flowUrls.overzichtUrlFor(leadAanvraag.aanvraagId, aanbodDefinitie.aanbodNaam)
        );
        break;
      case viewType.betaalOverzicht:
        await router.push(
          flowUrls.betaaloverzichtUrlFor(leadAanvraag.aanvraagId, aanbodDefinitie.aanbodNaam)
        );
        break;
      case viewType.page:
        await router.push(
          `/${lang.value}/${aanbodDefinitie.aanbodNaam}/${nextPagePointer.subflow}/${nextPagePointer.page}?aanvraagId=${leadAanvraag.aanvraagId}`
        );
        break;
      default:
        {
          rootStore.setErrorNotFound();
        }
        break;
    }
  }

  return {
    loadFromPermalink
  };
};
